import ValueForMoneySummaries from './ValueForMoneySummaries'

export default ValueForMoneySummaries
